import { render, staticRenderFns } from "./EditTextLink.vue?vue&type=template&id=c0f1bbce&scoped=true&"
import script from "./EditTextLink.vue?vue&type=script&lang=js&"
export * from "./EditTextLink.vue?vue&type=script&lang=js&"
import style0 from "./EditTextLink.vue?vue&type=style&index=0&id=c0f1bbce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f1bbce",
  null
  
)

export default component.exports